// extracted by mini-css-extract-plugin
export default {"container":"UiDatepicker_container_JF3pI","datepicker":"UiDatepicker_datepicker_WFgTS","datepickerPopup":"UiDatepicker_datepickerPopup_cYIPb"};